import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('joinUs/add',param)
}

export function update(param) {
  return axiosInstance.post('joinUs/edit',param)
}

export function del(param) {
	return axiosInstance.post('joinUs/del', param)
}

export function query(param) {
  return axiosInstance.post('joinUs/query',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryJoinUs(param) {
  return axiosInstance.post('joinUs/query',param)
}